'use client';

import {AppsSelectionContent} from '@web-catalog/types';

import styles from './TextComponent.module.scss';

export const TextComponent = ({
  content,
}: {
  content: AppsSelectionContent & {type: 'TEXT'};
}) => (
  <div className={styles.container} data-testid="text-comp">
    <h2 className={styles.title} data-testid="title">
      {content?.title}
    </h2>
    <p className={styles.text} data-testid="text">
      {content.text}
    </p>
  </div>
);
